import { renderElementList, deserializeList, onKeyDownList } from '@udecode/slate-plugins';
import { renderListElement } from './ListElement'
/**
 * Enables support for bulleted, numbered and to-do lists.
 */
export const ListPlugin = (options) => ({
  renderElement: renderListElement(options),
  deserialize: deserializeList(options),
  onKeyDown: onKeyDownList(options),
  // inlineTypes: ['ul']
});